import styled from "@emotion/styled";

export const ConnectOption = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  font-size: 14px;
  width: 85%;
`;

export const ConnectButton = styled.button`
  background-color: #1f8feb;
  box-shadow: none;
  border: none;
  color: white;
  font-size: 14px;
  font-weight: bold;
  padding: 10px 45px;
  border-radius: 10px;
  margin: 20px 0;
  cursor: pointer;
  width: 100%;
  max-width: 300px;
`;

export const ConnectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  padding: 0 20px;
  font-size: 14px;
  color: #aaa;
`;

export const Divider = styled.hr`
  border: 0;
  margin: 20px 0;
  height: 1px;
  background: #888;
  width: 80%;
`;

export const SkipOption = styled.div`
  font-size: 12px;
  cursor: pointer;
  margin=top: 10px;
  color: #888;
`;
